export default "__VITE_ASSET__Dtl89xAI__"